import { render, staticRenderFns } from "./AlertInstanceList.vue?vue&type=template&id=2990ae1c&scoped=true"
import script from "./AlertInstanceList.vue?vue&type=script&lang=js"
export * from "./AlertInstanceList.vue?vue&type=script&lang=js"
import style0 from "./AlertInstanceList.vue?vue&type=style&index=0&id=2990ae1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2990ae1c",
  null
  
)

export default component.exports